// ==========================================
// preloadBackgrounds.js
// Lade alle Background-Bilder vor, die mit
// "background_" im Dateinamen beginnen.
// ==========================================

// Hilfsfunktion: importiert dynamisch alle passenden Dateien
function importAll(r) {
  return r.keys().map(r);
}

// Alle Hintergrundbilder automatisch erfassen
export const backgrounds = importAll(
  require.context("../assets", false, /background_.*\.(png|jpg|jpeg|PNG|JPG)$/)
);

// Preload-Funktion
export function preloadBackgrounds() {
  backgrounds.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
}
